import angular from 'angular';

angular
  .module('settings.embed')
  .controller('settingsEmbedCtrl', settingsEmbedCtrl);

settingsEmbedCtrl.$inject = ['$translate'];

export default function settingsEmbedCtrl($translate) {
  var vm = this;
  var textWebsite = $translate.instant('general.website');

  vm.embedDestinations = [
    // { name: "Bitrix CMS", domain: "bitrix24.ru" },
    { name: 'Wix', domain: 'wix.com' },
    { name: 'Drupal', domain: '', img: '/img/logos/Drupal_Logo_128.jpg' },
    { name: 'PHP-' + textWebsite, domain: 'php.net' },
    { name: 'WordPress', domain: 'wordpress.com' },
    { name: 'Tilda', domain: 'tilda.cc' },
    { name: 'Webflow', domain: 'webflow.com' },
    {
      name: 'HTML-' + textWebsite,
      domain: '',
      img: '/img/logos/HTML5_Logo_128.png',
    },
  ];
}
